import { render } from "./HasNoAssetsModalContent.vue?vue&type=template&id=84bdc67a"
import script from "./HasNoAssetsModalContent.vue?vue&type=script&lang=js"
export * from "./HasNoAssetsModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/HasNoAssetsModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84bdc67a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84bdc67a', __exports__)) {
    api.reload('84bdc67a', __exports__)
  }
  
  module.hot.accept("./HasNoAssetsModalContent.vue?vue&type=template&id=84bdc67a", () => {
    api.rerender('84bdc67a', render)
  })

}


export default __exports__